export const DURATION = 'DURATION';
export const DAY_OR_TIME = 'DAY_OR_TIME';
export const DAY = 'DAY';
export const TIME = 'TIME';